import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowSplitRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowSplitRight"><Path d="M21 10H19V6.41406L13.4141 12L19 17.5859V14H21V21H14V19H17.5859L11.5859 13H3V11H11.5859L17.5859 5H14V3H21V10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowSplitRight;
